export default {
  config: {
    options: {
      label: 'Statut'
    }
  },
  dataModel: {
    types: ['pair:TaskStatus'],
    fieldsMapping: {
      title: 'pair:label'
    }
  }
};
